export const environment = {
  production: false,
  api_server: `https://dev-api.smartresponse.org`,
  ga_config: 'UA-37022280-2',
};
